/****************************************************
 * Module Name:  virtualTeamUserColumnPermission.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Box, Typography } from "@mui/material";
import Constants from "../../utility/constants";
import DualListBox from "react-dual-listbox";
import "react-dual-listbox/lib/react-dual-listbox.css";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import BlockIcon from "@mui/icons-material/Block";
import AddTaskIcon from "@mui/icons-material/AddTask";
import VirtualTeamProxy from "../../utility/proxy/manager/permissionProxy/virtualTeamProxy";
import Utility from "../../utility/utility";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import { LoadingButton } from "@mui/lab";
import UserColumnPermissionProxy from "../../utility/proxy/manager/permissionProxy/userColumnPermissionProxy";

const fullOptionToValue = (virtualteamid, selectedData) => {

  let permissions = [];
  selectedData.map((option) => permissions.push(option.sendValue));
  const data = {
    virtualteamid: virtualteamid,
    permissions: permissions,
  };
  return data;
};

const VirtualTeamUserColumnPermission = () => {
  const [virtualTeam, setVirtualTeam] = useState("");
  const [virtualTeamOptions, setVirtualTeamOptions] = useState([]);
  const [selected, setSelected] = useState([]);
  const [permissionOption, setPermissionOption] = useState([]);
  const [successSnackbar, setSuccessSnackbar] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [grantLoader, setGrantLoader] = useState(false);
  const [revokeLoader, setRevokeLoader] = useState(false);
  // eslint-disable-next-line
  const [local_Permission, setLocal_Permission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid ===
        Constants.PERMISSIONS.PERMISSION_USERPERMISSION_VIRTUALTEAM
    )
  );

  useEffect(() => {
    getAllVirtualTeam();
    getAllVirtualTeamPermission();
  }, []);

  const onChange = (value) => {
    setSelected(value);
  };

  const getAllVirtualTeam = () => {
    VirtualTeamProxy.GetAllVirtualTeamMini((response) => {
      if (response) {
        setAllVirtualTeamData(response)
      } else {
        setErrorSnackbar(true)
      }
    }
    );
  };

  const setAllVirtualTeamData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.id, label: data.name };
      optionsArray.push(option);
      return true;
    });
    setVirtualTeamOptions(optionsArray);
    setVirtualTeam(
      virtualTeam === "" && optionsArray.length > 0
        ? optionsArray[0]
        : virtualTeam
    );
  };

  const getAllVirtualTeamPermission = () => {
    UserColumnPermissionProxy.GetAllColumnPermission((response) => {
      if (response) {
        setAllVirtualTeamPermissionData(response)
      } else {
        setErrorSnackbar(true)
      }
    }
    );
  };

  const setAllVirtualTeamPermissionData = (response) => {
    let optionsArray = [];
    let uniqueId = 0;
    response.map((option) => {
      let option1 = {
        value: ++uniqueId,
        label: option.columnname,
        sendValue: option.id,
      };
      optionsArray.push(option1);
      return true;
    });
    setPermissionOption(optionsArray);
  };

  const handleGrantVirtualTeamColumnPermission = () => {
    let data = fullOptionToValue(virtualTeam.value, selected);
    setGrantLoader(true);
    UserColumnPermissionProxy.GrantPermissionToVirtualTeam(
      data,
      (response) => {
        if (response.status === "Success") {
          setSnackMessage(response);
          setSuccessSnackbar(true);
          setGrantLoader(false);
        } else {
          setSnackMessage(response);
          setErrorSnackbar(true);
          setGrantLoader(false);
        }
      }
    );
  };

  const handleRevokeVirtualTeamColumnPermission = () => {
    let data = fullOptionToValue(virtualTeam.value, selected);
    setRevokeLoader(true);
    UserColumnPermissionProxy.RevokePermissionFromVirtualTeam(
      data,
      (response) => {
        if (response.status === "Success") {
          setSnackMessage(response);
          setSuccessSnackbar(true);
          setRevokeLoader(false);
        } else {
          setSnackMessage(response);
          setErrorSnackbar(true);
          setRevokeLoader(false);
        }
      }
    );
  };

  return (
    <Box>
      <TabMenuSnackbar
        show={errorSnackbar}
        message={snackMessage.errorMessage}
        variant={"error"}
        autoHide={Constants.SnackBarCloseTimer}
        title={"Error"}
        handleClose={() => setErrorSnackbar(false)}
      />
      {successSnackbar ? (
        <TabMenuSnackbar
          show={true}
          message={<Box>{snackMessage.errorMessage}</Box>}
          variant={snackMessage.status.toLowerCase()}
          autoHide={snackMessage.status === "Success" ? true : false}
          handleClose={() => setSuccessSnackbar(false)}
          title={snackMessage.status}
        />
      ) : null}
      <Box
        sx={{
          display: "flex",
          minWidth: "350px",
          maxWidth: "auto",
          gap: "20px",
          mb: 1,
          px: 1
        }}
      >
        <Box sx={{ alignSelf: "center", mt: 2 }}>
          <Typography>Virtual Team</Typography>
        </Box>
        <Box
          sx={{
            alignSelf: "center",
            minWidth: "350px",
            maxWidth: "auto",
            mt: 2,
          }}
        >
          <Select menuPlacement="auto"
            blurInputOnSelect={false}
            className="basic-single"
            classNamePrefix="select"
            value={virtualTeamOptions.find(
              (ivirtualTeam) => ivirtualTeam.value === virtualTeam.value
            )}
            isSearchable={true}
            name="VirtualTeam"
            menuPortalTarget={document.body}
            styles={Constants.Styles}
            options={virtualTeamOptions}
            onChange={(selectedOption) => setVirtualTeam(selectedOption)}
          />
        </Box>
      </Box>
      <Box
        sx={{

          "& .rdl-controls": {
            minHeight: "550px",
            maxHeight: "700px",
          },
          backgroundColor: '#fff',
          color: '#000',
          height: '55vh',
          padding: 1
        }}
      >
        <DualListBox
          canFilter
          filterPlaceholder={"Search Permissions"}
          showHeaderLabels
          simpleValue={false}
          options={permissionOption}
          selected={selected}
          onChange={onChange}
          icons={{
            moveLeft: <KeyboardArrowLeftIcon />,
            moveAllLeft: <KeyboardDoubleArrowLeftIcon />,
            moveRight: <KeyboardArrowRightIcon />,
            moveAllRight: <KeyboardDoubleArrowRightIcon />,
          }}
        />
      </Box>
      <Box
        sx={{
          backgroundColor: '#fff',
          color: '#000',
          paddingBottom: 5,
          paddingRight: 5
        }}
        height={'15vh'}
        display="flex"
        alignItems="end"
        justifyContent="end"
        gap={"15px"}
      >
        {Utility.isUpdateAllowed(local_Permission) ||
          Utility.isAddAllowed(local_Permission) ? (
          <LoadingButton
            variant="contained"
            loading={grantLoader}
            loadingPosition="start"
            startIcon={<AddTaskIcon />}
            onClick={handleGrantVirtualTeamColumnPermission}
            disabled={virtualTeamOptions.length === 0 || selected.length === 0 || revokeLoader}
          >
            Grant
          </LoadingButton>
        ) : null}
        {Utility.isUpdateAllowed(local_Permission) ||
          Utility.isDeleteAllowed(local_Permission) ? (
          <LoadingButton
            sx={{ bgcolor: "#1a237e" }}
            loading={revokeLoader}
            loadingPosition="start"
            variant="contained"
            component="label"
            startIcon={<BlockIcon />}
            onClick={handleRevokeVirtualTeamColumnPermission}
            disabled={virtualTeamOptions.length === 0 || selected.length === 0 || grantLoader}
          >
            Revoke
          </LoadingButton>
        ) : null}
      </Box>
    </Box>
  );
};

export default VirtualTeamUserColumnPermission;
